import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Rate, Row, Col, Typography } from "antd";
import moment from "moment";
import { Button } from "@/components";
import { useStores } from "@/store";
import { useMemo } from "react";
import Gallery from "react-bnb-gallery";

/**评分&评论 */
export const Review = ({ id, reviews, reviews_count, reviews_ratings }) => {
  const { t } = useTranslation();
  const { dealStore } = useStores();
  const [page, setPage] = useState(1);
  const [photoList, setPhotoList] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [realLoad, setRealLoad] = useState(false);
  const [reviewList, setReviewList] = useState([]);
  const showMore = useMemo(() => {
    return reviews_count > 1 && reviewList.length < reviews_count;
  }, [reviews_count, reviewList]);

  useEffect(() => {
    setReviewList([reviews[0]]);
  }, []);

  async function onLoadMore() {
    setLoading(true);
    if (realLoad) {
      let list = reviewList.slice();
      let data = await dealStore.getReviews(id, page);
      list = list.concat(data);
      setPage(page++);
      setReviewList(list);
    } else {
      setRealLoad(true);
      setReviewList(reviews);
    }
    setLoading(false);
  }

  function onPreview(index, photos) {
    setPhotoList(photos.map(i=>({photo: i.image_url})))
    setShow(true)
  }

  return (
    <section className="page-deal--review">
      <h3>{t("WEB.Reviews", { count: reviews_count })}</h3>
      <div className="review-rate">
        <Rate count={5} value={reviews_ratings.ratings_avg / 2} disabled />
      </div>
      <div className="review-rate-desc">
        <span>
          {t("WEB.Food")}: {reviews_ratings.cuisine_avg}
        </span>
        <span>
          {t("WEB.Service")}: {reviews_ratings.service_avg}
        </span>
        <span>
          {t("WEB.Decoration")}: {reviews_ratings.atmosphere_avg}
        </span>
      </div>
      {reviewList.map((item, index) => {
        return <ReviewItem review={item} key={item.id + '_' + index} onPreview={onPreview} />;
      })}
      {showMore && (
        <Button type="primary" block onClick={onLoadMore} loading={loading} >
          {t("WEB.Show more reviews")}
        </Button>
      )}
      <Gallery
        onClose={() => setShow(false)}
        photos={photoList}
        show={show}
        showThumbnails={false}
      ></Gallery>
      <div className="hairline-bottom-new"  style={{paddingBottom:'20px'}} ></div>
    </section>
  );
};

const ReviewItem = ({ review, onPreview }) => {
  const { t } = useTranslation();
  const date = moment(review.created_at).format("yyyy-MM-DD");
  const { avatar_url, level } = review.member || {};
  const {
    photos = [],
    rating_atmosphere,
    rating_cuisine,
    rating_service,
  } = review;
  const avg = (rating_atmosphere + rating_cuisine + rating_service) / 3 / 2;
  return (
    <div className="review-item">
      <div className="review-avatar">
        <div className="review-avatar-pic">
          <img src={avatar_url} alt="" />
        </div>
        <div className="review-level">
          <i className={"icon icon-"+level}></i>
        </div>
        <div className="review-levelname">{t(`LEVELS.${level}`)}</div>
      </div>
      <div className="review-info">
        <div className="review-author">{review.name_reviewer}</div>
        <time className="review-date">
          <span className="small">{date}</span>
        </time>
        <div className="review-tag" hidden={!review.verified}>
          <i className="icon icon-verified"></i>
          <span className="small">{t("WEB.Verified")}</span>
        </div>
        <Rate count={5} value={avg} disabled />
        <div className="review-desc">
          <Typography.Paragraph ellipsis={{ rows: 2 }}>
            {review.review_text}
          </Typography.Paragraph>
          <div className="pc-text">{review.review_text}</div>
        </div>
        <div className="review-pics">
          <Row gutter={6} justify="start">
            {photos.map((item, index) => {
              let photo = `${item.image_url}?imageView2/1/w/88/h/66/interlace/1`.replace('??', '?')
              return <Col span={8} index={index} xm={{span: 8}} md={{span: 4}}>
                <div className="review-pic">
                  <img src={photo} onClick={() => onPreview(index, photos)} />
                </div>
              </Col>;
            })}
          </Row>
        </div>
      </div>
    </div>
  );
};
